// src/constants.js
export const OILS = [
  "Groundnut","Safflower","Sunflower","Flaxseed",
  "Coconut","Mustard","Almond","Sesame"
];

export const SKUS = ["100ml","250ml","500ml","1L","5L","15L"];

export const SKU_LITRES = {
  "100ml": 0.1, "250ml": 0.25, "500ml": 0.5,
  "1L": 1, "5L": 5, "15L": 15
};

export const OIL_COLORS = {
  Groundnut: "#BA7517",
  Safflower:  "#E24B4A",
  Sunflower:  "#EF9F27",
  Flaxseed:   "#534AB7",
  Coconut:    "#0F6E56",
  Mustard:    "#639922",
  Almond:     "#993C1D",
  Sesame:     "#185FA5",
};

export const USERS = [
  { id:"vaibhav", name:"Vaibhav",  role:"Plant Head",    pin:"7284", plant:true,  shop:false, admin:false },
  { id:"pande",   name:"Pande",    role:"Shopkeeper",     pin:"5391", plant:false, shop:true,  admin:false },
  { id:"jyoti",   name:"Jyoti",    role:"Admin & Owner",  pin:"8163", plant:true,  shop:true,  admin:true  },
  { id:"kadam",   name:"Kadam",    role:"Admin & Owner",  pin:"4729", plant:true,  shop:true,  admin:true  },
  { id:"rk",      name:"RK",       role:"Admin & Owner",  pin:"6047", plant:true,  shop:true,  admin:true  },
  { id:"balu",    name:"Balu da",  role:"Admin & Owner",  pin:"3815", plant:true,  shop:true,  admin:true  },
  { id:"ank",     name:"ANK",      role:"Admin & Owner",  pin:"9362", plant:true,  shop:true,  admin:true  },
  { id:"vb",      name:"VB",       role:"Admin & Owner",  pin:"2758", plant:true,  shop:true,  admin:true  },
];

export const USER_COLORS = {
  vaibhav: "#639922",
  pande:   "#185FA5",
  default: "#854F0B",
};

export const DEFAULT_YIELDS = {
  Groundnut: { oil: 42, cake: 53 },
  Safflower:  { oil: 35, cake: 60 },
  Sunflower:  { oil: 38, cake: 57 },
  Flaxseed:   { oil: 38, cake: 56 },
  Coconut:    { oil: 63, cake: 32 },
  Mustard:    { oil: 36, cake: 58 },
  Almond:     { oil: 50, cake: 44 },
  Sesame:     { oil: 48, cake: 47 },
};

export const LOW_STOCK_THRESHOLD_KG = 50;
